import React, { useState } from 'react';
import { Wrapper, CheckboxWrapper, Label } from './styled';

export const Checkbox = ({label, value, onChange}) => {
  const [checked, setChecked] = useState(value);
  const handleClick = () => {
      setChecked(!checked);
      if (onChange) {
          onChange(!checked);
      }
  };

  return (
    <Wrapper>
      <CheckboxWrapper
        label={label}
        checked={checked}
        onClick={handleClick}
      >
        <span />
      </CheckboxWrapper>
      { label && <Label onClick={handleClick}>{label}</Label> }
    </Wrapper>
  );
};

export default Checkbox;
